import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { PieChart, Pie, Cell, ResponsiveContainer, LabelList } from 'recharts';
import { useForm } from 'react-hook-form';
import MoonLoader from "react-spinners/MoonLoader";

function CDaywise({ IP, TOKEN, UserObj }) {

    const COLORS = ['#f78716', '#012951'];  //absent , present
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [summary, setSummary] = useState([])
    const [isLoading, setLoading] = useState(false)
    const [maxDate, setMaxDate] = useState("");

    const getSummary = async (formData) => {
        setLoading(true)
        await axios.get(`http://${IP}/get-summary/${TOKEN}/${UserObj.college}/${formData.Date}`)
            .then(res => {
                if (res.data.error === true) {
                    notifyError(res.data.msg)
                }
                if (res.data.error === false) {
                    setSummary(res.data.Summary)
                }
            })
            .catch((err) => console.log(err))
        setLoading(false)
    }

    useEffect(() => {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        const fulldate = yyyy + "-" + mm + "-" + dd
        setMaxDate(fulldate)
        // getSummary(fulldate)
    }, [])

    const notifyError = (msg) => {
        toast.error(msg, {
            toastId: 3,
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            width: "fit-content"
        });
    }

    return (
        <div>
            <div className='m-auto' style={{ maxWidth: "1300px" }}>
                {/* <h6 className='pt-0'>Filter By</h6> */}
                <form className='mb-4 mt-2 p-0' onSubmit={handleSubmit(getSummary)}>
                    <div className='row'>
                        <div className="form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4 ">
                            <label htmlFor='date' className='me-2'><small>Select date</small></label>
                            <input type="date" id="date" className="form-control form-control-sm" min="2022-11-28" max={maxDate} {...register("Date", { required: true })} />
                            {errors.Date && <span className='text-danger'>Date is required</span>}
                        </div>
                        <div className='form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4'>
                            <label htmlFor='fsdate' className='me-2'></label><br />
                            <button className='btn btn-sm btn-primary'>Get Summary</button>
                        </div>
                    </div>
                </form>
            </div>
            {
                isLoading ?
                    <div className='pb-5 mb-5'>
                        <h3 className='text-center mt-4'>Loading please wait...</h3>
                        <MoonLoader
                            className='mx-auto moonloader'
                            color="#012951"
                            loading={isLoading}
                            speedMultiplier={1}
                        />
                    </div>
                    :
                    <div className='row p-2'>
                        {
                            summary.map((obj, index) =>
                                <div key={index} className='card ps-0 col-md-4 mb-4  border-0 daywise-chart' style={{ width: '26rem', margin: 'auto' }}>
                                    <div className="card-body d-flex">
                                        {/* {obj.percentageData[1].value}<br />
                                        {obj.percentageData[0].value} */}
                                        <div>
                                            <h6 style={{
                                                color: '#f78716',
                                                position: 'absolute',
                                                width: '110px',
                                                top: '43%',
                                                textAlign: 'center',
                                            }}>
                                                {obj.percentageData[0].value}%
                                            </h6>
                                            <PieChart width={110} height={110}>
                                                <Pie
                                                    data={obj.percentageData}
                                                    // cx={120}
                                                    // cy={200}
                                                    innerRadius={25}
                                                    outerRadius={50}
                                                    fill="#eee"
                                                    paddingAngle={0}
                                                    dataKey="value"
                                                // label
                                                >
                                                    {obj.percentageData.map((entry, index) => (
                                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                    ))}
                                                </Pie>
                                            </PieChart>
                                        </div>
                                        <div className='w-100 ps-4'>
                                            <p className="card-title text-end" style={{ fontSize: '20px', fontWeight: 500, color: '#012951' }}>{obj.name}</p>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <p className="card-text">Absent</p>
                                                <p className="card-text">Present</p>
                                                <p className="card-text">Total</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <h5 className="card-text">
                                                    {
                                                        obj.present === 0 ?
                                                            <span>--</span>
                                                            :
                                                            obj.total - obj.present
                                                    }
                                                </h5>
                                                <h5 className="card-text">
                                                    {
                                                        obj.present === 0 ?
                                                            <span>--</span>
                                                            :
                                                            obj.present
                                                    }
                                                </h5>
                                                <h5 className="card-text">{obj.total}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
            }
            <ToastContainer />
        </div>
    );
}

export default CDaywise;